import { render, staticRenderFns } from "./RegionCascader.vue?vue&type=template&id=8c8fc298&"
import script from "./RegionCascader.vue?vue&type=script&lang=js&"
export * from "./RegionCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports